import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import userAPI from "../api/userApi";

const SiteConfigContext = createContext();

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSiteDetails();
  }, []);

  const fetchSiteDetails = async () => {
    try {
      const cachedConfig = sessionStorage.getItem("site_config");

      if (cachedConfig) {
        const parsed = JSON.parse(cachedConfig);
        const isExpired = Date.now() - parsed.timestamp > 60 * 60 * 1000; // 5 min cache

        if (!isExpired) {
          setConfig(parsed.data);
          setLoading(false);
          return;
        }
      }

      const res = await userAPI.details();

      if (res.code === 200) {
        setConfig(res.data);
        sessionStorage.setItem(
          "site_config",
          JSON.stringify({ data: res.data, timestamp: Date.now() }),
        );
      }
    } catch (err) {
      console.error("Failed to fetch site config", err);
    } finally {
      setLoading(false);
    }
  };

  const siteConfig = useMemo(
    () => ({
      siteName: config?.company_name || "Royal Agate",
      logo: config?.logo?.replace(" ", "%20") || "/logo.png",
      phone: config?.phone || "",
      whatsapp: config?.whatsapp || "",
      email: config?.school_email || "",
      address: config?.register_office || "",
      facebook: config?.facebook || "",
      instagram: config?.instagram || "",
    }),
    [config],
  );

  return (
    <SiteConfigContext.Provider value={{ siteConfig, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
